import JSZip from 'jszip';
import { download } from 'utilities/file';
import ExcelJS from 'exceljs';
import { sortBy } from 'utilities/sorting';
import {
  buildColumnsArray,
  getROCYear,
  getMonthDates,
} from '../../CountyPrsReport/workbooks/helpers';


const specialDistrictPrice = ['豐濱', '銅門', '和平'];

export default async function byTripsAndDistrict({
  elders,
  orders: allOrders,
  deliveryStaffs,
  selectedMonth: selectedYearMonth = 'YYYY-MM',
  clientName,
  includeUndeliveredOrders = false,
  excludeNonFoodDeliveryOrders = false,
  applyDefaultDeliveryStaff = false,
}) {
  let includedOrderStatus = ['delivered', 'completed'];
  if (includeUndeliveredOrders) {
    includedOrderStatus = includedOrderStatus.concat(['ready', 'readyForPickup', 'delivering']);
  }
  let orders = allOrders
    .filter(({ elderId }) => elders.some(({ id }) => id === elderId))
    .filter(({ status }) => includedOrderStatus.includes(status));
  if (excludeNonFoodDeliveryOrders) {
    orders = orders.filter(({ category }) =>
      ['送餐', '送餐和物資', '愛心餐', '自費餐'].includes(category));
  }

  const [selectedYear, selectedMonth] = selectedYearMonth.split('-');
  const ROCYear = parseInt(selectedYear) - 1911;

  const zip = new JSZip();

  const workbookDeliveryStaff = new ExcelJS.Workbook();
  const worksheet = workbookDeliveryStaff.addWorksheet(`${ROCYear}${selectedMonth}送餐大使薪資表`);
  getWorksheetDeliveryStaff(worksheet, deliveryStaffs, orders, elders, selectedYearMonth, selectedMonth, applyDefaultDeliveryStaff);
  try {
    if (workbookDeliveryStaff && workbookDeliveryStaff.worksheets && workbookDeliveryStaff.worksheets.length > 0) {
      const bufferDataByDistrict = await workbookDeliveryStaff.xlsx.writeBuffer();
      zip.file(`${ROCYear}${selectedMonth}送餐大使薪資表.xlsx`, bufferDataByDistrict, { binary: true });
    }
  } catch (e) {
    console.error(e);
  }

  const files = Object.keys(zip.files);
  if (files.length !== 0) {
    const zipContent = zip.generate({ type: 'blob' });
    download(`${clientName}__${selectedYearMonth}送餐大使薪資表.zip`, zipContent);
  }
}

function getWorksheetDeliveryStaff(worksheet, deliveryStaffs = [], orders = [], elders, selectedYearMonth, selectedMonth, applyDefaultDeliveryStaff) {
  const monthDates = getMonthDates(selectedYearMonth, 'dddd');
  const deliveryStaffRows = [];
  deliveryStaffs
    .sort((a, b) => a.name > b.name ? 1 : - 1)
    .map(({ id, name }) => {
      // find staff's order
      const deliveryStaffOrders = orders.filter(({ deliveryStaffId }) => deliveryStaffId === id);
      // if order =0
      if (deliveryStaffOrders.length === 0) {
        return;
      }
      // if order != 0
      const statistics = [];

      deliveryStaffOrders.sort(sortBy('deliveryBy')).forEach(({ mealSlot, date, elderId }) => {
        // find order's elder
        const elder = elders.find(({ id }) => id === elderId);
        if (!elder) return;


        let elderDistrict = elder.address.district;
        specialDistrictPrice.forEach((specialDistrict, _) => {
          if (Object.values(elder.address).some( (Address) =>{
            return String(Address).includes(specialDistrict);
          })) {
            elderDistrict = elderDistrict + '(偏遠)';
          }
        });


        // count district's orders
        const matched = statistics.find((item) => item.date === date && item.mealSlot === mealSlot && item.district === elderDistrict);
        if (matched) {
          matched.mealCount += 1;
        } else {
          statistics.push({
            date,
            mealSlot,
            district: elderDistrict,
            mealCount: 1,
          });
        }
      });
      deliveryStaffRows.push({ name, statistics });
    });


  const fontName = 'Calibri';
  const range = 'A:CZ';
  const columnArray = buildColumnsArray(range);

  const ROCYear = getROCYear(selectedYearMonth);

  let rowIndex = 1;

  const defaultBorder = { top: { style: 'thin' }, bottom: { style: 'thin' }, right: { style: 'thin' }, left: { style: 'thin' } };

  let cell;
  worksheet.mergeCells(`A${rowIndex}:S${rowIndex}`);
  cell = worksheet.getCell(`A${rowIndex}`);
  cell.value = `${ROCYear}年${selectedMonth}月送餐大使薪資表`;
  cell.alignment = { horizontal: 'center', vertical: 'middle' };
  cell.font = { size: 48, name: fontName };
  rowIndex += 1;

  // column A
  cell = worksheet.getCell(`A${rowIndex}`);
  cell.value = '';
  cell.border = defaultBorder;
  cell = worksheet.getCell(`A${rowIndex + 1}`);
  cell.value = '';
  cell.border = defaultBorder;
  cell = worksheet.getCell(`A${rowIndex + 2}`);
  cell.value = '日期';
  cell.alignment = { horizontal: 'center', vertical: 'middle' };
  cell.font = { size: 16, name: fontName };
  cell.border = defaultBorder;
  monthDates.forEach(({ label }, index) => {
    cell = worksheet.getCell(`A${rowIndex + 3 + index}`);
    cell.value = `${index + 1}(${label.replace('星期', '')})`;
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;
  });
  ['小計', '送餐員合計', '總送餐日', '當月最高日薪', '合計薪資'].forEach((value, index) => {
    cell = worksheet.getCell(`A${rowIndex + 3 + monthDates.length + index}`);
    cell.value = value;
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;
  });

  worksheet.getColumn('A').width = 20;

  let columnIndex = 1;
  deliveryStaffRows.forEach(({ name, statistics }) => {
    let currentRowIndex = rowIndex;
    const lunchDistricts = new Set(
      statistics.filter(({ mealSlot }) => mealSlot === 'lunch').map(({ district }) => district),
    );
    const lunchDistrictsCount = lunchDistricts.size;
    const dinnerDistricts = new Set(
      statistics.filter(({ mealSlot }) => mealSlot === 'dinner').map(({ district }) => district),
    );
    const dinnerDistrictsCount = dinnerDistricts.size;
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      worksheet.mergeCells(
        `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`,
      );
    }
    cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
    cell.value = name;
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;
    currentRowIndex += 1;

    // title
    if (lunchDistrictsCount) {
      if (lunchDistrictsCount > 1) {
        worksheet.mergeCells(
          `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount - 1]}${currentRowIndex}`,
        );
      }
      cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
      cell.value = '午餐';
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.font = { size: 16, name: fontName };
      cell.border = defaultBorder;
    }
    if (dinnerDistrictsCount) {
      if (dinnerDistrictsCount > 1) {
        worksheet.mergeCells(
          // eslint-disable-next-line max-len
          `${columnArray[columnIndex + lunchDistrictsCount]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount - 1]}${currentRowIndex}`,
        );
      }
      cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount]}${currentRowIndex}`);
      cell.value = '晚餐';
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.font = { size: 16, name: fontName };
      cell.border = defaultBorder;
    }
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`);
      cell.value = '當日薪資';
      cell.alignment = { horizontal: 'center', vertical: 'middle' };
      cell.font = { size: 16, name: fontName };
      cell.border = defaultBorder;
      worksheet.getColumn(columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]).width = 15;
    }
    currentRowIndex += 1;

    // 填值
    if (lunchDistrictsCount) {
      Array.from(lunchDistricts).sort().forEach((district, districtIndex) => {
        cell = worksheet.getCell(`${columnArray[columnIndex + districtIndex]}${currentRowIndex}`);
        // fill distict
        cell.value = district;
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { size: 16, name: fontName };
        cell.border = defaultBorder;

        // fill each day's meals
        monthDates.forEach(({ date }, dateIndex) => {
          const matched = statistics.find((item) => item.date === date && item.mealSlot === 'lunch' && item.district === district);
          let value = '';
          if (matched) {
            value = matched.mealCount;
          }
          cell = worksheet.getCell(`${columnArray[columnIndex + districtIndex]}${currentRowIndex + dateIndex + 1}`);
          cell.value = value;
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.font = { size: 16, name: fontName };
          cell.border = defaultBorder;
        });

        //
        const currentCell = `${columnArray[columnIndex + districtIndex]}${currentRowIndex + monthDates.length + 1}`;
        cell = worksheet.getCell(currentCell);
        // 計算小計
        // eslint-disable-next-line max-len
        cell.value = { formula: `SUM(${columnArray[columnIndex + districtIndex]}5:${columnArray[columnIndex + districtIndex]}${currentRowIndex + monthDates.length})` };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { size: 16, name: fontName };
        cell.border = defaultBorder;
        worksheet.getColumn(columnArray[columnIndex + districtIndex]).width = 25;
      });
    }
    if (dinnerDistrictsCount) {
      Array.from(dinnerDistricts).sort().forEach((district, districtIndex) => {
        cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + districtIndex]}${currentRowIndex}`);

        cell.value = district;
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { size: 16, name: fontName };
        cell.border = defaultBorder;
        monthDates.forEach(({ date }, dateIndex) => {
          const matched = statistics.find((item) => item.date === date && item.mealSlot === 'dinner' && item.district === district);
          let value = '';
          if (matched) {
            value = matched.mealCount;
          }
          cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + districtIndex]}${currentRowIndex + dateIndex + 1}`);
          cell.value = value;
          cell.alignment = { horizontal: 'center', vertical: 'middle' };
          cell.font = { size: 16, name: fontName };
          cell.border = defaultBorder;
        });
        const currentCell = `${columnArray[columnIndex + lunchDistrictsCount + districtIndex]}${currentRowIndex + monthDates.length + 1}`;
        cell = worksheet.getCell(currentCell);
        // eslint-disable-next-line max-len
        cell.value = { formula: `SUM(${columnArray[columnIndex + lunchDistrictsCount + districtIndex]}5:${columnArray[columnIndex + lunchDistrictsCount + districtIndex]}${currentRowIndex + monthDates.length})` };
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { size: 16, name: fontName };
        cell.border = defaultBorder;
        worksheet.getColumn(columnArray[columnIndex + lunchDistrictsCount + districtIndex]).width = 25;
      });
    }
    // 計算當日薪資
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`);
      cell.border = defaultBorder;
      // 計算非偏遠地區的數量 * 錢 + 偏遠地區 * 500
      monthDates.forEach(({ date }, dateIndex) => {
        const notRemoteOrder = statistics.filter((item) =>{
          return item.date == date && !item.district.includes('偏遠');
        } );
        const notRemoteOrderCount = Object.values(notRemoteOrder).reduce((acc, { mealCount }) => acc + mealCount, 0);
        const RemoteOrder = statistics.filter((item) =>{
          return item.date == date && item.district.includes('偏遠');
        } );
        const RemoteOrderCount = Object.values(RemoteOrder).reduce((acc, { mealCount }) => acc + mealCount, 0);

        let dailySalary = 0;
        if (notRemoteOrderCount > 0) {
          dailySalary = 200 + 50 * Math.floor((notRemoteOrderCount-1) / 5 );
        }

        if (RemoteOrderCount > 0) {
          dailySalary = dailySalary + 500;
        }

        cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex + dateIndex + 1}`);
        if (dailySalary > 0) {
          cell.value = dailySalary;
        }
        cell.alignment = { horizontal: 'center', vertical: 'middle' };
        cell.font = { size: 16, name: fontName };
        cell.border = defaultBorder;
      });

      cell = worksheet.getCell(`${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex + monthDates.length + 1}`);
      cell.border = defaultBorder;
    }

    //
    // 計算送餐員合計
    currentRowIndex += monthDates.length + 2;
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      worksheet.mergeCells(
        `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`,
      );
    }
    cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
    // eslint-disable-next-line max-len
    cell.value = { formula: `SUM(${columnArray[columnIndex]}${currentRowIndex - 1}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount - 1]}${currentRowIndex - 1})` };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;
    currentRowIndex += 1;

    // 總送餐日
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      worksheet.mergeCells(
        `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`,
      );
    }
    cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
    // eslint-disable-next-line max-len
    cell.value = { formula: `COUNTA(${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}5:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${monthDates.length + 4})` };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;
    currentRowIndex += 1;

    // 每月最高日薪
    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      worksheet.mergeCells(
        `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`,
      );
    }
    cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
    // eslint-disable-next-line max-len
    cell.value = { formula: `MAX(${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}5:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${monthDates.length + 4})` };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;

    currentRowIndex += 1;

    // 合計薪資

    if (lunchDistrictsCount + dinnerDistrictsCount > 0) {
      worksheet.mergeCells(
        `${columnArray[columnIndex]}${currentRowIndex}:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${currentRowIndex}`,
      );
    }
    cell = worksheet.getCell(`${columnArray[columnIndex]}${currentRowIndex}`);
    // eslint-disable-next-line max-len
    cell.value = { formula: `${columnArray[columnIndex]}${currentRowIndex -1} *COUNTA(${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}5:${columnArray[columnIndex + lunchDistrictsCount + dinnerDistrictsCount]}${monthDates.length + 4})` };
    cell.alignment = { horizontal: 'center', vertical: 'middle' };
    cell.font = { size: 16, name: fontName };
    cell.border = defaultBorder;

    columnIndex += lunchDistrictsCount + dinnerDistrictsCount + 1;
  });

  rowIndex += monthDates.length + 10;
  worksheet.mergeCells(`A${rowIndex}:S${rowIndex + 4}`);
  cell = worksheet.getCell(`A${rowIndex}`);
  cell.value = '業務承辦：         業務主管：            主任：            董事長：';
  cell.alignment = { horizontal: 'center', vertical: 'middle' };
  cell.font = { size: 36, name: fontName };


  return worksheet;
}


